const {
  evaluateSource
} = require(/* configBehaviorIgnore: true */'../lib/evaluateSource');

/**
  * @function evalute - evaluate nestedOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = source2 => evaluateSource(source2, content, parentContentPath, transientContext, nativeFunctions);
  const {
    nestedOptions = []
  } = source;
  if (nestedOptions.length === 0) {
    return undefined;
  }
  let nestingLevel = 0;
  const {
    selection
  } = transientContext;
  if (selection !== undefined) {
    const [value] = Object.values(selection);
    nestingLevel = value === null || value === void 0 ? void 0 : value.nestingLevel;
  }
  const item = nestedOptions[nestingLevel];
  const result = {};
  const options = await sourceEvaluator(item.options);
  if (options !== undefined) {
    const hasChildren = nestingLevel < nestedOptions.length - 1;
    const keys = Object.keys(options);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const value = options[key];
      value.nestingLevel = nestingLevel + 1;
      value.hasChildren = hasChildren;
    }
    result.options = options;
  }
  const title = await sourceEvaluator(item.title);
  if (title !== undefined) {
    result.title = title;
  }
  const keep = await sourceEvaluator(item.keep);
  if (keep !== undefined) {
    result.keep = keep;
  }
  return result;
};
module.exports = {
  evaluate
};